import axios from '../../../axios';
import IUser from '../types/IUser';

export const getDomainType = (email: string) => axios.post('/api/verify_domain', email);
export const verifyEmail = (email: string) => axios.post('/api/verify_email', email);
export const signupCreateAccount = (user: IUser) => axios.post('/api/register', user);
export const resendActivationLink = (email: string) =>
  axios.post('/api/resend_activation_link', email);
